import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0d9ddf2b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-wrap pt-20 pb-20" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row mb-5" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-2" }, "Exhortations à la cérémonie académique", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-3" }, " Exhortations adressées à ceux qui ont achevé leur formation académique. ", -1))
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table table-bordered table-striped" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "table-light" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Dates"),
    /*#__PURE__*/_createElementVNode("th", null, "Thèmes"),
    /*#__PURE__*/_createElementVNode("th", null, "Communicateurs")
  ])
], -1))
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "blog-card style1" }
const _hoisted_12 = {
  class: "blog-info",
  style: {"min-height":"250px"}
}
const _hoisted_13 = { class: "blog-metainfo list-style" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-calendar" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-right-arrow" }, null, -1))
const _hoisted_17 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exhortationsAcademiques, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(item.date), 1),
                    _createElementVNode("td", null, _toDisplayString(item.theme), 1),
                    _createElementVNode("td", null, _toDisplayString(item.communicateur), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.truncatedArticles, (article, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-4 col-lg-6 col-md-6",
            key: index
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                class: "blog-img",
                style: _normalizeStyle({height:'277px', backgroundImage: `url(${_ctx.getUrlApiForFiles(article.urlImage)})`, backgroundSize: 'cover',backgroundPosition: 'center'})
              }, null, 4),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("ul", _hoisted_13, [
                  _createElementVNode("li", null, [
                    _hoisted_14,
                    _createTextVNode(),
                    _createVNode(_component_router_link, { to: "#" }, {
                      default: _withCtx(() => [
                        _createTextVNode("L' École d’Initiation Théologique et Pastorale")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _hoisted_15,
                    _createTextVNode(_toDisplayString(_ctx.format_Date(article.datePublication)), 1)
                  ])
                ]),
                _createElementVNode("h3", null, [
                  _createVNode(_component_router_link, {
                    to: { name: 'ViewArticlePage', params: { id: article.id } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(article.titre), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createVNode(_component_router_link, {
                  to: { name: 'ViewArticlePage', params: { id: article.id } },
                  class: "link style1"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Lire plus "),
                    _hoisted_16
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}